<app-widget-option [categories]="['LAYERS']" [label]="'DISPLAY_REMAINING'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).gaugeDisplayRemaining" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>